/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    {
        name: 'GlobalStyles',
        import: () => import('@stories/Widgets/Global/GlobalStyles/GlobalStyles'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'Header',
        import: () => import('@stories/Widgets/Global/Header/Header'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'Footer',
        import: () => import('@stories/Widgets/Global/Footer/Footer'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'Breadcrumbs',
        import: () => import(/* webpackChunkName: 'Breadcrumbs' */ '@stories/Widgets/Breadcrumbs/Breadcrumbs'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'InnerHeroBanner',
        import: () => import(/* webpackChunkName: 'InnerHeroBanner' */ '@stories/Widgets/InnerHeroBanner/InnerHeroBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ArticleListingGrid',
        import: () => import(/* webpackChunkName: 'ArticleListingGrid' */ '@stories/Widgets/ArticleListingGrid/ArticleListingGrid'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'GenericListingGrid',
        import: () => import(/* webpackChunkName: 'GenericListingGrid' */ '@stories/Widgets/GenericListingGrid/GenericListingGrid'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ArticleDetailsStyles',
        import: () => import(/* webpackChunkName: 'ArticleDetailsStyles' */ '@stories/Widgets/ArticleDetails/ArticleDetails.styles'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'ArticleBottom',
        import: () => import(/* webpackChunkName: 'ArticleBottom' */ '@stories/Widgets/ArticleDetails/ArticleBottom/ArticleBottom'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ArticleSideContent',
        import: () => import(/* webpackChunkName: 'ArticleSideContent' */ '@stories/Widgets/ArticleDetails/ArticleSideContent/ArticleSideContent'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'QuoteBlock',
        import: () => import(/* webpackChunkName: 'QuoteBlock' */ '@stories/Widgets/ArticleDetails/QuoteBlock/QuoteBlock'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'ArticleDetailsHeader',
        import: () => import(/* webpackChunkName: 'ArticleDetailsHeader' */ '@stories/Widgets/ArticleDetailsHeader/ArticleDetailsHeader'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'RichTextStyles',
        import: () => import(/* webpackChunkName: 'RichTextStyles' */ '@stories/Widgets/RichText.styles'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'HeroBanner',
        import: () => import(/* webpackChunkName: 'HeroBanner' */ '@stories/Widgets/HeroBanner/HeroBanner'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'MediaAndText',
        import: () => import(/* webpackChunkName: 'MediaAndText' */ '@stories/Widgets/MediaAndText/MediaAndText'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'GenericContentCarousel',
        import: () => import(/* webpackChunkName: 'GenericContentCarousel' */ '@stories/Widgets/GenericContentCarousel/GenericContentCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ArticleCardCarousel',
        import: () => import(/* webpackChunkName: 'ArticleCardCarousel' */ '@stories/Widgets/ArticleCardCarousel/ArticleCardCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'USPStatsBlock',
        import: () => import(/* webpackChunkName: 'USPStatsBlock' */ '@stories/Widgets/USPStatsBlock/USPStatsBlock'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'GenericDetails',
        import: () => import(/* webpackChunkName: 'GenericDetails' */ '@stories/Widgets/GenericDetails/GenericDetails'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TestimonialsBlock',
        import: () => import(/* webpackChunkName: 'TestimonialsBlock' */ '@stories/Widgets/TestimonialsBlock/TestimonialsBlock'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Accordion',
        import: () => import(/* webpackChunkName: 'Accordion' */ '@stories/Widgets/Accordion/Accordion'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PeopleCards',
        import: () => import(/* webpackChunkName: 'PeopleCards' */ '@stories/Widgets/PeopleCards/PeopleCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'DocumentList',
        import: () => import(/* webpackChunkName: 'DocumentList' */ '@stories/Widgets/DocumentList/DocumentList'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ImageAndVideoGallery',
        import: () => import(/* webpackChunkName: 'ImageAndVideoGallery' */ '@stories/Widgets/ImageAndVideoGallery/ImageAndVideoGallery'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Timeline',
        import: () => import(/* webpackChunkName: 'Timeline' */ '@stories/Widgets/Timeline/Timeline'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'NewsCardCarousel',
        import: () => import(/* webpackChunkName: 'NewsCardCarousel' */ '@stories/Widgets/NewsCardCarousel/NewsCardCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SearchResults',
        import: () => import(/* webpackChunkName: 'SearchResults' */ '@stories/Widgets/SearchResults/SearchResults'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CallBackFormStyles',
        import: () => import(/* webpackChunkName: 'CallBackFormStyles' */ '@stories/Widgets/CallBackForm/CallBackForm.styles'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'UmbracoFormStyles',
        import: () => import(/* webpackChunkName: 'UmbracoFormStyles' */ '@stories/Components/Misc/Forms/UmbracoForm/UmbracoForm'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'CallBackFormLeftContent',
        import: () => import(/* webpackChunkName: 'CallBackFormLeftContent' */ '@stories/Widgets/CallBackForm/CallBackFormLeftContent/CallBackFormLeftContent'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ImageBlock',
        import: () => import(/* webpackChunkName: 'ImageBlock' */ '@stories/Widgets/ArticleDetails/ImageBlock/ImageBlock'),
        config: {
            hydrate: 'in-view',
        },
    },
];
